import React, { Component } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import classnames from "classnames";
import authLogo from "../../images/authLogo2.png"
import browser from 'browser-detect'
import Bowser from "bowser"

// import action
import { login, getGeoInfoData } from "../../actions/admin";

// import lib
import { toastAlert } from '../../lib/toastAlert';

const initialFormValue = {
    'email': '',
    'password': '',
    'twoFACode': '',
    'isTerms': false
}

class Login extends Component {
    constructor() {
        super();
        this.state = {
            errors: {},
            showTwoFA: false,
            formvalue: initialFormValue,
            loginHistory: {}

        };
    }

    getGeoInfo = async () => {
        try {
            let { result } = await getGeoInfoData();

            const browserResult = await browser();
            const Browser = Bowser.getParser(window.navigator.userAgent)
            this.setState({
                loginHistory:
                    ({
                        countryName: result.country_name,
                        countryCode: result.country_calling_code,
                        ipaddress: result.ip,
                        region: result.region,
                        broswername: `${Browser.parsedResult.browser.name}${Browser.parsedResult.browser.version}`,
                        ismobile: browserResult.mobile,
                        os: Browser.parsedResult.os.name,
                    })
            })
        }
        catch (err) {
        }
    };

    onChange = e => {

        const { name, value } = e.target

        if (name == 'twoFACode') {
            if (!(value == '' || (/^[0-9\b]+$/.test(value) && value.length <= 6))) {
                return
            }
        }
        this.setState({ formvalue: { ...this.state.formvalue, ...{ [name]: value } } })
    };


    onSubmit = async e => {
        e.preventDefault();
        const { email, password, twoFACode, isTerms } = this.state.formvalue
        const { dispatch, history } = this.props;
        const reqData = {
            email: email,
            password: password,
            twoFACode: twoFACode,
            loginHistory: this.state.loginHistory

        };
        try {
            const { status, loading, message, error } = await login(reqData, dispatch);
            if (status == 'success') {
                history.push("/dashboard");
                toastAlert('success', message, 'login')
            } else {
                if (error) {
                    this.setState({ errors: error })
                }
                toastAlert('error', message, 'login')
            }
            if (status == 'TWO_FA') {
                this.setState({
                    showTwoFA: true
                })
                // setShowTowFA(true)
                toastAlert('success', message, 'login');
            }
        } catch (err) { }
    };

    componentWillMount() {
        this.getGeoInfo()
    }

    render() {
        const { errors, showTwoFA, twoFACode, formvalue, loginHistory } = this.state;
        return (
            <div className="container">
                <div className="row mt-5">
                    <div className="col-md-4 mx-auto mt-5 card shadow-lg">
                        <div className="card-body p-2">
                            <center className="pt-3"><img src={authLogo} className="img-fluid" alt="" /></center>
                            <h2 className="text-center text-primary mt-3">Login</h2>
                            <form noValidate onSubmit={this.onSubmit} className="white">
                                <label htmlFor="email">Email</label>
                                <input
                                    onChange={this.onChange}
                                    value={this.state.email}
                                    error={errors.email}
                                    id="email"
                                    type="email"
                                    name='email'
                                    className={classnames("form-control", {
                                        invalid: errors.email
                                    })}
                                />
                                <span className="text-danger">{errors.email}</span>
                                <br />
                                <label htmlFor="password">Password</label>
                                <input
                                    onChange={this.onChange}
                                    value={this.state.password}
                                    error={errors.password}
                                    id="password"
                                    type="password"
                                    name='password'
                                    className={classnames("form-control", {
                                        invalid: errors.password
                                    })}
                                />
                                <span className="text-danger">{errors.password}</span>


                                {
                                    this.state.showTwoFA && <div className="form-group">
                                        <label htmlFor="Enter 2FA Code">Enter 6 Digit 2FA Code</label>
                                        <input
                                            onChange={this.onChange}
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter 2FA Code"
                                            name="twoFACode"
                                            value={this.state.twoFACode}

                                        />
                                        {/* {validateError.twoFACode && <p className="error-message">{t(validateError.twoFACode)}</p>} */}
                                    </div>
                                }


                                <p className="text-center pb-0 mt-2">
                                    <button
                                        type="submit"
                                        className="btn btn-large btn-primary mt-2 px-5">
                                        Login
                                    </button>
                                </p>
                                <p className="grey-text text-darken-1">
                                    Don't have an account? <Link to="/forgot">Forgot Password?</Link>
                                </p>


                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(null, null)(Login);
